import { Component, OnInit } from "@angular/core";
import { ApiService } from "../../common/services/api.service";

@Component({
    selector: "app-hospitals-list",
    templateUrl: "./hospitals-list.component.html",
    styleUrls: ["./hospitals-list.component.scss"],
})
export class HospitalsListComponent implements OnInit {
    hospitals: any[] = [];

    constructor(private apiService: ApiService) {
        this.fillHospitals();
    }

    ngOnInit(): void {}

    fillHospitals() {
        this.apiService.getHospitals().subscribe((res: any) => {
            console.log(res);
            if (!res) return;
            this.hospitals = res;
        });
    }
}
